<template>
  <div class="alert" :class="{ '-danger': !finished || errors.unrecognized, '-success': finished && !errors.unrecognized }">
    <template v-if="!finished || errors.unrecognized">
      <p class="title">Ops!</p>

      <p>
        Para acessar a plataforma confirme sua conta clicando no link que foi enviado para o seu e-mail.
        Não recebeu o e-mail? <button type="button" class="btn-link" @click="resendConfirmationEmail">Clique aqui para reenviar</button>.
      </p>

      <p v-if="errors.unrecognized">
        Ocorreu um erro ao tentar enviar o e-mail, por favor tente novamente.
      </p>
    </template>

    <p v-if="finished">
      Enviamos a você um novo e-mail. Clique no link deste e-mail para confirmar sua conta
    </p>

    <loader v-if="loading"></loader>
  </div>
</template>

<script>
import Loader from '@/support/components/Loader.vue';

export default {
  name: 'AlertLoginForbidden',

  props: {
    forbiddenEmail: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      email: '',
      finished: false,
      loading: false,
      errors: {
        unrecognized: false,
      },
    };
  },

  methods: {
    /**
     * Register the user.
     *
     * @returns {Promise<void>}
     */
    async resendConfirmationEmail() {
      try {
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/resendConfirmationEmail', { email: this.email });

        this.finished = true;
      } catch (err) {
        this.errors.unrecognized = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.unrecognized = false;
    },
  },

  mounted() {
    this.email = this.forbiddenEmail;
  },

  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>
  .alert {
    @apply relative;
  }
</style>
